import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ExtendedParametersTabsEnum,
  RemoteDiagnosticsParameter,
  RemoteDiagnosticsStore,
  RemoteDiagnosticsUseCasesStore,
} from '@store';

import { DiagnosticsWebsocketService } from '../diagnostics-websocket.service';
import { RemoteDiagnosticsSuccessResponseData } from '../../../../../../projects/client';

@Component({
  selector: 'app-diagnostics-parameters',
  templateUrl: './diagnostics-parameters.component.html',
  styleUrls: ['./diagnostics-parameters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsParametersComponent implements OnInit, OnDestroy {
  readonly extendedParametersTabsEnum = ExtendedParametersTabsEnum;

  selectedExtendedParametersTab$: Observable<ExtendedParametersTabsEnum>;
  gatewaySerial: string;
  isAnyParameterSelectedByUser: boolean;
  isAnyUseCaseParameterSelected: boolean;
  selectedParameters: RemoteDiagnosticsParameter[];
  isParameterListFull$: Observable<boolean>;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    public activatedRoute: ActivatedRoute,
    private diagnosticsWebsocketService: DiagnosticsWebsocketService<
      RemoteDiagnosticsSuccessResponseData
    >,
    protected remoteDiagnosticsUseCasesStore: RemoteDiagnosticsUseCasesStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];
    this.remoteDiagnosticsStore.cancelMultipleParametersReadCycle(this.gatewaySerial);
    this.isParameterListFull$ = this.remoteDiagnosticsStore.isParameterListFull(this.gatewaySerial);

    this.selectedExtendedParametersTab$ = this.remoteDiagnosticsUseCasesStore.getSelectedExtendedParametersTab(
      this.gatewaySerial
    );

    this.remoteDiagnosticsStore
      .getSelectedParameters(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectedParameters) => {
        this.selectedParameters = selectedParameters;
        this.cdr.detectChanges();
      });

    this.diagnosticsWebsocketService.initializeWebsocket(this.gatewaySerial);
  }

  ngOnDestroy(): void {
    this.diagnosticsWebsocketService.ngUnsubscribe.next();
    this.diagnosticsWebsocketService.ngUnsubscribe.complete();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  parameterByIdTrackBy(_index: number, parameter: RemoteDiagnosticsParameter): number {
    return parameter.id;
  }
}
